import { jsx as _jsx } from "react/jsx-runtime";
import { LengthInput } from "../primitives/LengthInput";
export const VariableStringEditor = ({ value, onChangeValue, readOnly, onClickValue, placeholderValue })=>{
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        className: onClickValue ? "cursor-pointer" : "",
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(LengthInput, {
                iconType: "node-text",
                readOnly: !!readOnly,
                placeholder: (placeholderValue === null || placeholderValue === void 0 ? void 0 : placeholderValue.value) || "",
                value: (value === null || value === void 0 ? void 0 : value.value) || "",
                onClick: (e)=>{
                    onClickValue && e.preventDefault();
                    onClickValue && onClickValue();
                },
                onChange: (e)=>{
                    onChangeValue && onChangeValue({
                        type: "variable-string",
                        value: e.target.value
                    });
                }
            })
        })
    });
};
